<template>
  <b-row>
    <form @submit.prevent class="col-12 col-sm-9">
      <b-card class="mb-3" :header="heading" no-body>
        <div class="card-body">
          <b-row>
            <b-form-group class="col-8" label="Name:">
              <b-form-input
                id="osi-input-name"
                v-model="itemForm.name"
                v-validate="{ required: true, min: 2 }"
                name="osi-input-name"
                :state="validateState('osi-input-name')"
                data-vv-as="Name"
              />
              <b-form-invalid-feedback id="osi-input-name-feedback">
                {{ veeErrors.first('osi-input-name') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group class="col-4" label="Status:">
              <b-v-select
                v-model="itemForm.integrationStatus"
                name="osi-input-status"
                :options="integrationStatusOpts"
              />
            </b-form-group>

            <b-form-group class="col-12" label="For Client:">
              <b-v-select
                id="osi-input-brandId"
                v-model="itemForm.brandId"
                v-validate="{ required: true }"
                :searchable="true"
                name="osi-input-brandId"
                :state="validateState('osi-input-brandId')"
                data-vv-as="Client"
                :options="brandsList"
                :disabled="!!(itemForm.id && !is('developer'))"
              />
              <b-form-invalid-feedback id="osi-input-brandId-feedback">
                {{ veeErrors.first('osi-input-brandId') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group class="col-12" label="Order Number Prefix:">
              <b-form-input v-model="itemForm.orderNumberPrefix" />
            </b-form-group>

            <b-form-group class="col-12" label="From LaCore Warehouse:">
              <b-v-select
                v-model="itemForm.warehouseId"
                :searchable="true"
                name="osi-input-warehouseId"
                :options="warehousesListAll"
              />
            </b-form-group>
          </b-row>
        </div>
      </b-card>

      <b-card class="mb-3" header="Integration Config" no-body>
        <div class="card-body">
          <b-row>
            <IntegrationSystemSelect
              :is-storefront-config="false"
              v-model="itemForm.integrationSystem"
            />
          </b-row>
          <StorefrontIntegrationSystemConfigCards
            :storefront="itemForm"
            :validate-state="validateState"
            :is-order-source-integration="true"
            @reload="id && LoadItem(id)"
          />
        </div>
      </b-card>
    </form>

    <aside class="col-12 col-sm-3 d-flex flex-column">
      <b-card header="Actions" class="order-last order-sm-first">
        <b-button
          :disabled="savingItem"
          variant="primary"
          block
          @click="SaveForm"
        >
          <span v-if="savingItem">Saving...</span>
          <span v-else>Save Changes</span>
        </b-button>
        <router-link
          class="mt-2 btn btn-block btn-outline-danger"
          :to="{ name: 'Integrations.OrderSourceIntegrations.Index' }"
        >Cancel</router-link>
      </b-card>

      <b-card header="Integration Settings" class="mt-3" v-if="itemForm.integrationSystem && itemForm.integrationSystem !== 'Manual'">
       <!--- <b-form-group label="">
          <b-form-checkbox v-model="itemForm.integrationTrackingSyncIsEnabled" name="check-button" switch>
            Sync Shipment Tracking Updates
          </b-form-checkbox>
        </b-form-group>-->
        <b-form-group label="">
          <b-form-checkbox v-model="itemForm.integrationInventorySyncIsEnabled" :disabled="true" name="check-button" switch>
            Enable Inventory Sync
          </b-form-checkbox>
        </b-form-group>
      </b-card>
    </aside>
  </b-row>
</template>

<script>
import IntegrationSystemSelect from '@/views/components/StorefrontIntegrationSystemSelect';
import StorefrontIntegrationSystemConfigCards from '@/views/components/StorefrontIntegrationSystemConfigCards';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';

export default {
  name: 'Integrations.OrderSourceIntegrations.Form',
  mixins: [crudMixinGen('orderSourceIntegrations'), myCommonDataMixin],
  components: {
    IntegrationSystemSelect,
    StorefrontIntegrationSystemConfigCards
  },

  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: function() {
    return {
      heading: 'Order Source Integration',
      integrationStatusOpts: [
        { value: 'Active', text: 'Active' },
        { value: 'Paused', text: 'Paused' },
        { value: 'Pending', text: 'Pending' },
        { value: 'Disabled', text: 'Disabled' }
      ]
    };
  },

  mounted: function() {
    if (this.id) {
      this.ResetForm();
      this.LoadItem(this.id);
    } else {
      this.ResetForm();
    }
  },

  methods: {
    SaveForm: function() {
      var self = this;
      self.savingItem = true;
      self.SaveItem()
      .then(function() {
        self.ResetForm();
        self.$swal('Saved!', 'Order source integration saved successfully.', 'success');
        self.$router.push({ name: 'Integrations.OrderSourceIntegrations.Index' });
      })
      .catch(function(err) {
        self.savingItem = false;
        var msg = (err.response && err.response.data && err.response.data.errorMessage) || 'Item was not saved.';
        self.$swal('Error', msg, 'error');
      });
    }
  }
};
</script>
